import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";
import { createFeedCommentPayload } from "../models/feedCommentModel";

export const createFeedComment = async (values) => {
  const payload = createFeedCommentPayload(values);
  try {
    const response = await apiClient.post(ENDPOINTS.CREATE_FEED_COMMENT, payload, { timeout: 20000 });
    const result = response.data;
    if (result?.status !== true || result.data?.id == null || String(result.data.feed_id) !== String(payload.feed_id)) {
      throw new Error(result?.message || "The server did not confirm your reply. Check before sending again.");
    }
    return result.data;
  } catch (error) {
    if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") {
      throw new Error("Your reply could not be confirmed. Check before sending again to avoid a duplicate.");
    }
    throw new Error(error.response?.data?.message || error.message || "Unable to send your reply.");
  }
};

export const getFeedComments = async (feedId, { signal } = {}) => {
  if (!Number.isInteger(Number(feedId)) || Number(feedId) <= 0) throw new Error("Please select a valid post.");
  const response = await apiClient.get(ENDPOINTS.GET_FEED_COMMENTS(feedId), { signal, timeout: 20000 });
  const result = response.data;
  if (result?.status !== true || !Array.isArray(result.data) || result.data.some((comment) => comment?.id == null || String(comment.feed_id) !== String(feedId))) {
    throw new Error(result?.status === false ? result.message || "Unable to load comments." : "Unable to load comments.");
  }
  return result.data;
};
